import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const PracticeTour = ({ autoStart = true, onComplete }) => {
  const { startTour } = useShepherdTour('practice', TOUR_DATA.practice.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Practice Tour
    </button> */}
    </>
  );
};

export default PracticeTour;
